import { getResourceTrendAPI } from "@/apis/usage-api"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { create } from "zustand"

export const resourceTrendStore = create((set) => ({
  period: 7,
  setPeriod: (period) => set({ period }),

  trendMap: {},

  apiGetResourceTrend: async ({ period }) => {
    const { sido, kapt_code, ended_at } = aptSearchStore.getState().pickApt

    const trendMap = await getResourceTrendAPI({
      sido,
      kapt_code,
      period,
      ended_at
    })
    set({ trendMap })
  }
}))
